import { store } from "@/stores/Store"

class Service {
    public isTabsVisible(): boolean {
        return store.getters.showTabs
    }
    public showTabs(): void {
        store.commit("showTabs");
        console.log(store.state);

    }
    public hideTabs(): void {
        store.commit("hideTabs")
    }
}

export const TabService: Service = new Service();
